module.exports = __webpack_public_path__ + "media/images/category/feature/poj/hero-056c0b9c4770b53d9b729bb79263bcb3.jpg";